import TextField from '@/components/TextField/TextField';
import { theme } from '@de-id/ui-components';
import styled from '@emotion/styled';

export const InputField = styled(TextField)`
    & .MuiOutlinedInput-root {
        height: 40px;
        border-radius: 8px;

        color: ${theme.colors.secondary.main};
        font-family: Manrope;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: -0.14px;
    }

    & .MuiFormHelperText-root {
        color: ${theme.colors.error[650]};
        font-family: Manrope;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: 16px;
        margin-top: 4px;
        margin-left: 0;
    }

    & .MuiInputBase-input {
        padding: 10px 14px;
        border-radius: 8px;
        outline: none;
        background-color: transparent;
    }
`;
